import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
  show: boolean = false;

  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      this.show = true
    }, 500);
  }

}
